import React from 'react';
import DataResource from './../../../common/DataResource'
import Panel from './../../../common/layout/Panel'


export default class extends React.Component {
    render () {
        const accountId = this.props.match.params.account_id;
        const today = new Date();
        const data = {
            url: `/admin/clients/accounts/${accountId}/smslog`,
            limit: 50,
            offset: 0,
            userfilter:
            [
                {
                    source: 'ATRTIMESTAMP',
                    label: 'Date',
                    type: 'date_range',
                    default: {
                        'from' : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                        'to': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
                    }
                },
                {
                    source: 'ATRDESTADDR',
                    label: 'Dest. Address',
                    type: 'text',
                    default: ''
                },
                {
                    source: 'ATRSRCADDR',
                    label: 'Source Address',
                    type: 'text',
                    default: ''
                },
                {
                    source: 'ATRMSGTYPE',
                    label: 'Message Type',
                    type: 'select',
                    default: ''
                },
                {
                    source: 'ATRDIRECTION',
                    label: 'Direction',
                    type: 'select',
                    default: ''
                }
            ],
            datalen: 0,
            datarows: [],
            servermeta: [],
            loading: false,
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRMESSAGEID',
                        type: 'primary',
                        visible: false
                    },
                    {
                        label: 'Timestamp',
                        source: 'ATRTIMESTAMP',
                        type: 'datetime',
                    },
                    {
                        label: 'Type',
                        source: 'ATRMSGTYPE',
                        type: 'icon',
                        values : {
                            sms: 'SMS',
                            mms: 'MMS'
                        },
                        classnames : {
                            mms: 'label label-info',
                            sms: 'label label-warning'
                        }
                    },
                    {
                        label: 'Direction',
                        source: 'ATRDIRECTION',
                        type: 'icon',
                        values : {
                            in: 'MO',
                            out: 'MT'
                        },
                        classnames : {
                            in: 'label label-info',
                            out: 'label label-warning'
                        }
                    },
                    {
                        label: 'Carrier',
                        source: 'CARRIER',
                        type: 'text'
                    },
                    {
                        label: 'Dest. Address',
                        source: 'ATRDESTADDR',
                        type: 'text'
                    },
                    {
                        label: 'Src. Address',
                        source: 'ATRSRCADDR',
                        type: 'text'
                    },
                    {
                        label: 'Dest. Network',
                        source: 'ATRCLIENTDESTNAME',
                        type: 'text'
                    },
                    {
                        label: 'Billed Amount',
                        source: 'ATRCLIENTAMOUNT',
                        type: 'text'
                    },
                    {
                        label: 'Cost',
                        source: 'ATRCARRIERAMOUNT',
                        type: 'text'
                    },
                    {
                        label: 'Msg Parts',
                        source: 'ATRNUMPARTS',
                        type: 'text'
                    },
                    {
                        label: 'Msg Size',
                        source: 'ATRMSGSIZE',
                        type: 'text'
                    },
                    {
                        label: 'View',
                        url: 'admin/clients/accounts/'+ accountId +'/smslog/',
                        type: 'popup',
                        title: 'SMS Message Details',
                        fields: [
                            {
                                source: 'ATRMESSAGEID',
                                label: 'Message ID',
                                type: 'text'
                            },
                            {
                                source: 'ATRTIMESTAMP',
                                label: 'Timestamp',
                                type: 'datetime'
                            },
                            {
                                source: 'ATRDESTADDR',
                                label: 'Dest. Address',
                                type: 'text'
                            },
                            {
                                label: 'Carrier',
                                source: 'CARRIER',
                                type: 'text'
                            },
                            {
                                label: 'Dest. Network',
                                source: 'ATRCLIENTDESTNAME',
                                type: 'text'
                            },
                            {
                                source: 'ATRSRCADDR',
                                label: 'Source Address',
                                type: 'text'
                            },
                            {
                                label: 'Billed Amount',
                                source: 'ATRCLIENTAMOUNT',
                                type: 'text'
                            },
                            {
                                label: 'Cost',
                                source: 'ATRCARRIERAMOUNT',
                                type: 'text'
                            },
                            {
                                label: 'Msg Parts',
                                source: 'ATRNUMPARTS',
                                type: 'text'
                            },
                            {
                                label: 'Msg Size',
                                source: 'ATRMSGSIZE',
                                type: 'text'
                            },
                            {
                                source: 'ATRDESTADDRTON',
                                type: 'enum',
                                label: 'Destination TON',
                                values: {
                                    UNKNOWN: '0 (Unknown)',
                                    INTERNATIONAL: '1 (International)',
                                    NATIONAL: '2 (National)',
                                    NETWORK_SPECIFIC: '3 (Network Specific)',
                                    SUBSCRIBER_NUMBER: '4 (Subscriber Number)',
                                    ALPHANUMERIC: '5 (Alphanumeric)',
                                    ABBREVIATED: '6 (Abbreviated)'
                                }
                            },
                            {
                                source: 'ATRDESTADDRNPI',
                                type: 'enum',
                                label: 'Destination NPI',
                                values: {
                                    UNKNOWN: '0 (Unknown)',
                                    ISDN: '1 (ISDN)',
                                    Data: '3 (Data)',
                                    Telex: '4 (Telex)',
                                    'Land mobile': '6 (Land mobile)',
                                    National: '8 (National)',
                                    Private: '9 (Private)',
                                    Ermes: '10 (Ermes)',
                                    Internet: '14 (Internet)',
                                    'WAP Client ID': '18 (WAP Client ID)'
                                }
                            },
                            {
                                source: 'ATRSRCADDRTON',
                                type: 'enum',
                                label: 'Source TON',
                                values: {
                                    UNKNOWN: '0 (Unknown)',
                                    INTERNATIONAL: '1 (International)',
                                    NATIONAL: '2 (National)',
                                    NETWORK_SPECIFIC: '3 (Network Specific)',
                                    SUBSCRIBER_NUMBER: '4 (Subscriber Number)',
                                    ALPHANUMERIC: '5 (Alphanumeric)',
                                    ABBREVIATED: '6 (Abbreviated)'
                                }
                            },
                            {
                                source: 'ATRSRCADDRNPI',
                                type: 'enum',
                                label: 'Source NPI',
                                values: {
                                UNKNOWN: '0 (Unknown)',
                                    ISDN: '1 (ISDN)',
                                    Data: '3 (Data)',
                                    Telex: '4 (Telex)',
                                    'Land mobile': '6 (Land mobile)',
                                    National: '8 (National)',
                                    Private: '9 (Private)',
                                    Ermes: '10 (Ermes)',
                                    Internet: '14 (Internet)',
                                    'WAP Client ID': '18 (WAP Client ID)'
                                }
                            },
                            {
                                source: 'ATRDATACODING',
                                type: 'enum',
                                label: 'Data Coding',
                                values: {
                                    0: '0 (SMSC Default Alphabet)',
                                    1: '1 (IA5 (CCITT T.50)/ASCII (ANSI X3.4))',
                                    2: '2 (Octet unspecified (8-bit binary))',
                                    3: '3 (Latin 1 (ISO-8859-1))',
                                    4: '4 (Octet unspecified (8-bit binary))',
                                    5: '5 (JIS (X 0208-1990))',
                                    6: '6 (Cyrllic (ISO-8859-5))',
                                    7: '7 (Latin/Hebrew (ISO-8859-8))',
                                    8: '8 (UCS2 (ISO/IEC-10646))',
                                    9: '9 (Pictogram Encoding)',
                                    10: '10 (ISO-2022-JP (Music Codes))',
                                    13: '13 (Extended Kanji JIS(X 0212-1990))',
                                    14: '14 (KS C 5601)'
                                }
                            },
                            {
                                source: 'ATRREGDELIVERY',
                                type: 'enum',
                                label: 'DLR Requested?',
                                values: {
                                    NO_SMSC_DELIVERY_RECEIPT_REQUESTED: '0 (NO_SMSC_DELIVERY_RECEIPT_REQUESTED)',
                                    SMSC_DELIVERY_RECEIPT_REQUESTED: '1 (SMSC_DELIVERY_RECEIPT_REQUESTED)',
                                    SMSC_DELIVERY_RECEIPT_REQUESTED_FOR_FAILURE: '2 (SMSC_DELIVERY_RECEIPT_REQUESTED_FOR_FAILURE)'
                                }
                            },
                            {
                                source: 'ATRSRCCONNECTOR',
                                type: 'enum',
                                label: 'Source Connector Type',
                                values: {
                                    smppsapi: 'SMPP',
                                    httpapi: 'Web or API'
                                }
                            },
                            {
                                source: 'server_name',
                                type: 'text',
                                label: 'Server'
                            },
                            {
                                source: 'ATRTEXT',
                                label: 'Text',
                                class: '',
                                type: 'textarea'
                            },
                        ],
                        footer: [
                            {
                                type: 'table',
                                title: 'SMS Delivery Reports',
                                source: 'dlrs',
                                condition: {
                                    field: 'ATRMSGTYPE',
                                    value: 'sms'
                                },
                                fields: [
                                    {
                                        source: 'ATRMSGSTATUS',
                                        type: 'text',
                                        label: 'Status'
                                    },
                                    {
                                        source: 'ATRTIMESTAMP',
                                        type: 'text',
                                        label: 'Timestamp'
                                    },
                                    {
                                        source: 'ATRSUBDATE',
                                        type: 'text',
                                        label: 'Subm Date'
                                    },
                                    {
                                        source: 'ATRDONEDATE',
                                        type: 'text',
                                        label: 'Done Date'
                                    },
                                    {
                                        source: 'ATRERR',
                                        type: 'text',
                                        label: 'Error'
                                    }
                                ],
                            },
                            {
                                type: 'table',
                                title: 'MMS Delivery Status',
                                source: 'mms_dlrs',
                                condition: {
                                    field: 'ATRMSGTYPE',
                                    value: 'mms'
                                },
                                fields: [
                                    {
                                        source: 'created_at',
                                        type: 'text',
                                        label: 'Timestamp'
                                    },
                                    {
                                        source: 'result',
                                        type: 'text',
                                        label: 'Result'
                                    },
                                    {
                                        source: 'error',
                                        type: 'text',
                                        label: 'Error'
                                    }
                                ],
                            }
                        ]
                    }
                ]
        }
    
        return (
            <Panel title = "SMS Log">
                <DataResource
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}

